import { Box, Button, Grid, Typography } from "@mui/material";
import { AppLayout } from "layout";
import React, { useState } from "react";

const SortDataCommon = ({
  activeDropdown,
  setActiveDropdown,
  onSortChange,
  onClearAll,
}: any) => {
  const handleClick = () => {
    setActiveDropdown(3);
  };
  const handleSortSelection = (sortOption: any) => {
    onSortChange(sortOption);
    setActiveDropdown(null);
  };

  return (
    <Grid display={"flex"} flexDirection={"column"} position={"relative"}>
      <Box onClick={handleClick} sx={styleSheet.CategoriesContainer}>
        <img src="/assets/icons/affsort.png" alt="sort" />
        Sort
      </Box>
      {activeDropdown == 3 && (
        <Box
          sx={{
            position: "absolute",
            top: "100%",
            zIndex: 1,
            width: { xs: "100%", md: 162 },
            bgcolor: "background.paper",
            borderRadius: "8px",
            mt: 1,
            p: 2,
          }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={2}
            fontSize={"17px"}
            fontWeight={400}
            color={"#313131"}
          >
            {[
              "Price low to high",
              "Price high to low",
              "Publication Date",
              "Best Selling",
            ].map((option) => (
              <Typography
                key={option}
                onClick={() => handleSortSelection(option)}
                sx={{ cursor: "pointer" }}
              >
                {option}
              </Typography>
            ))}

            <Box display="flex" alignItems="center" mb={2}>
              <Button
                variant="outlined"
                onClick={() => {
                  onClearAll(); // Trigger clear all
                  setActiveDropdown(null); // Close dropdown
                }}
              >
                Clear
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </Grid>
  );
};

export default SortDataCommon;

const styleSheet = {
  CategoriesContainer: {
    backgroundColor: "white",
    borderRadius: "15px",
    padding: "10px 8px",
    display: "flex",
    gap: 1,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "17px",
    fontWeight: "400px",
    width: "62px",
    // width: "78px",
    color: "#233F91",
    fontFamily: "Atten Round New",
  },
};
